import React from "react";
import CommentEditor from "../components/CommentEditor";
import "./editComment.scss";
import { useDetailEditCommentState } from "./hooks/useDetailEditCommentState";

export default React.memo( function EditTextFields({ cardId, messg, comment_id, setShowEdit }) {
  const {
    anchorEl,
    comment,
    editorRef,
    elementPos,
    handleCancel,
    handleChange,
    handleComment,
    handleMention,
    handleMentionClose,
    handleSave,
    handleUserSelect,
    isDisable,
    isMobile,
    mentionListVisible,
    selectedUserForTag,
    setElementPos,
    sortUser,
  } = useDetailEditCommentState({
    cardId,
    commentId: comment_id,
    initialComment: messg,
    setShowEdit,
  });

  return (
    <div className="d-flex align-items-center">
      <CommentEditor
        isMobile={isMobile}
        comment={comment}
        handleComment={handleComment}
        handleMention={handleMention}
        setElementPos={setElementPos}
        editorRef={editorRef}
        mentionListVisible={mentionListVisible}
        anchorEl={anchorEl}
        elementPos={elementPos}
        handleMentionClose={handleMentionClose}
        sortUser={sortUser}
        handleChange={handleChange}
        selectedUserForTag={selectedUserForTag}
        handleUserSelect={handleUserSelect}
        handleSave={handleSave}
        handleCancel={handleCancel}
        isDisable={isDisable}
        containerId="forAnchor1"
      />
    </div>
  );
})
